class HeaderColumn {
    constructor(displayName) {
        this.displayName = displayName;
    }
}

class ValueColumn extends HeaderColumn {
    constructor(objectKey, displayName) {
        super(displayName);
        this.objectKey = objectKey;
        this.isValueColumn = true;
    }
}

class SpecialColumn extends HeaderColumn { 
    constructor(displayName) {
        super(displayName);
        this.isSpecialColumn = true;
    }
}

class AdditionalWorklistColumn extends ValueColumn {
    constructor(objectKey, displayName) {
        super(objectKey, displayName);
        this.isAdditionalWorklistColumn = true;
    }
}

class HeaderService {
    getAllHeaders(serverResponse) {
        const staticHeaders = this._getStaticHeaders();

        const additionalHeaders = serverResponse.additionalWorkListFields
            .map((field) => this.getHeaderColumnForServiceValue(field))
            .filter((e) => typeof e !== 'undefined');

        return staticHeaders.concat(additionalHeaders);
    }

    getHeaderColumnForServiceValue(serviceValue) {
        return this._getMap()[serviceValue];
    }

    _getStaticHeaders() {
        return [
            new ValueColumn('orderId', 'Order Id'),
            new SpecialColumn('References'),
            new ValueColumn('type', 'Type'),

            new SpecialColumn('Confirm'),
            new SpecialColumn('Appt Start - End'),
            new SpecialColumn('Appt Reference Number'),
            new SpecialColumn('Preloaded Equipment Decal ID')
        ];
    }

    _getMap() {
        return {
            "Additional Information": new AdditionalWorklistColumn('additionalInformation', 'Additional Information'),
            "Additional Work List Fields": new AdditionalWorklistColumn('additionalWorkListFields', 'Additional Work List Fields'),
            "Appt Confidence": new AdditionalWorklistColumn('appointmentConfidence', 'Appt Confidence'),
            "Appt Confirmed": new AdditionalWorklistColumn('appointmentConfirmed', 'Appt Confirmed'),
            "Appointment Reference": new AdditionalWorklistColumn('appointmentReference', 'Appointment Reference'),
            "Capability Type": new AdditionalWorklistColumn('capabilityType', 'Capability Type'),
            "Destination Location City": new AdditionalWorklistColumn('destinationCity', 'Destination Location City'),
            "Destination Location Id": new AdditionalWorklistColumn('destinationLocationId', 'Destination Location Id'),
            "Destination Location Name": new AdditionalWorklistColumn('destinationLocationName', 'Destination Location Name'),
            "Destination Location State": new AdditionalWorklistColumn('destinationLocationState', 'Destination Location State'),
            "Equipment ID": new AdditionalWorklistColumn('equipment', 'Equipment ID'),
            "Ground Date Time": new AdditionalWorklistColumn('groundingDateTime', 'Ground Date'),
            "LOB": new AdditionalWorklistColumn('lineOfBusiness', 'Line Of Business'), //added - confirm with Yunus
            "Liable Party Id": new AdditionalWorklistColumn('liablePartyId', 'Liable Party Id'),
            "Liable Party Name": new AdditionalWorklistColumn('liablePartyName', 'Liable Party Name'),
            "Loc Address": new AdditionalWorklistColumn('locationAddress', 'Loc Address'),
            "Loc City": new AdditionalWorklistColumn('locationCity', 'Loc City'),
            "Loc Country": new AdditionalWorklistColumn('locationCountry', 'Loc Country'),
            "Loc Name": new AdditionalWorklistColumn('locationName', 'Loc Name'),
            "Loc State": new AdditionalWorklistColumn('locationState', 'Loc State'),
            "More Info Comments": new AdditionalWorklistColumn('moreInfoOrderComments', 'More Info Comments'),
            "Order Owner Id": new AdditionalWorklistColumn('orderOwner', 'Order Owner Id'),
            "Order Status": new AdditionalWorklistColumn('orderStatus', 'Order Status'),
            "Order Stop Num": new AdditionalWorklistColumn('orderStopNumber', 'Order Stop Num'),
            "Order Stop Seq Num": new AdditionalWorklistColumn('orderStopSequenceNumber', 'Order Stop Seq Num'),
            "Order Stop Total": new AdditionalWorklistColumn('orderStopTotal', 'Order Stop Total'),
            "Piece Count": new AdditionalWorklistColumn('pieceCount', 'Piece Count'),
            "Preloaded Equipment Decal Id": new AdditionalWorklistColumn('preloadedEquipmentDecal', 'Preloaded Equipment Decal ID'),
            "Appointment Profile Id": new AdditionalWorklistColumn('profileId', 'Appointment Profile Id'),
            "Rail Hub": new AdditionalWorklistColumn('railHub', 'Rail Hub'),
            "Related Appt End DTTM": new AdditionalWorklistColumn('relatedAppointmentEndDateTime', 'Related Appt End DTTM'),
            "Related Appt Start DTTM": new AdditionalWorklistColumn('relatedAppointmentStartDateTime', 'Related Appt Start DTTM'),
            "Related Loc City": new AdditionalWorklistColumn('relatedLocationCity', 'Related Loc City'),
            "Related Loc Name": new AdditionalWorklistColumn('relatedLocationName', 'Related Loc Name'),
            "Related Loc State": new AdditionalWorklistColumn('relatedLocationState', 'Related Loc State'),
            "Requested End DTTM": new AdditionalWorklistColumn('requestedEndDateTime', 'Requested End DTTM'),
            "Requested Start DTTM": new AdditionalWorklistColumn('requestedStartDateTime', 'Requested Start DTTM'),
            "Reschedule": new AdditionalWorklistColumn('isReschedule', 'Reschedule'),
            "Segment Code": new AdditionalWorklistColumn('segmentCode', 'Segment Code'),
            "Ship Exec Status": new AdditionalWorklistColumn('shipmentExecutionStatus', 'Ship Exec Status'),
            "Shipment Id": new AdditionalWorklistColumn('shipmentId', 'Shipment Id'),
            "Shipment Miles": new AdditionalWorklistColumn('shipmentMiles', 'Shipment Miles'),
            "Stop Action": new AdditionalWorklistColumn('stopAction', 'Stop Action'),
            "Stop Id": new AdditionalWorklistColumn('stopId', 'Stop Id'),
            "Tendering Party ID": new AdditionalWorklistColumn('tenderingPartyId', 'Tendering Party ID'),
            "Weight": new AdditionalWorklistColumn('weight', 'Weight'),
            "Work Status": new AdditionalWorklistColumn('workStatus', 'Work Status')
        }
    }
}

export const headerService = new HeaderService();